const green300Color = '#63d57e';

export default green300Color;
